import { FC } from 'react';
import { ControlProps, GroupBase, components } from 'react-select';
import { SelectOption } from '../models';

import styles from './ControlChain.module.sass';

const { Control } = components;

export type ControlChainProps = ControlProps<
  SelectOption,
  false,
  GroupBase<SelectOption>
>;

const ControlChain: FC<ControlChainProps> = (props) => {
  const { children, ...restProps } = props;
  return <Control {...restProps}>{children}</Control>;
};

export default ControlChain;
